import React, { useRef, useEffect } from 'react';
import fadeOut from '../../../helpers/animations/fadeOut';
import styles from './PopUp.module.css';

function PopUp({
  close, maxWidth, closeWithBackground, closeButton, children, callback, className, headerSize = 40,
}) {
  const refPopUp = useRef();

  const closeAnimation = () => {
    fadeOut(refPopUp.current, 300, () => {
      close();
      if (callback) callback();
    });
  };

  const handleCloseWithBackground = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();

      if (closeWithBackground) {
        closeAnimation();
      }
    }
  };

  const handleCloseWithButton = (e) => {
    e.stopPropagation();
    if (closeButton) {
      closeAnimation();
    }
  };

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div
      className={styles.popUp}
      ref={refPopUp}
      onClick={handleCloseWithBackground}
      onKeyUp={handleCloseWithBackground}
      role="button"
      tabIndex="0"
    >
      <div className={`${styles.popUpBody} ${styles.scrollbarGray}`} style={{ maxWidth: `${maxWidth}px`, '--headerSize': `${headerSize}px` }}>
        <div className={styles.popUpHeader}>
          {closeButton ? (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <div
              className={styles.xIcon}
              onClick={handleCloseWithButton}
              onKeyUp={handleCloseWithButton}
              role="button"
              tabIndex="0"
            />
          ) : null}
        </div>
        <div className={`${styles.popUpBodyContainer} ${className || ''}`}>
          {typeof children === 'function' ? children({ closeAnimation }) : children}
        </div>
      </div>
    </div>
  );
}

export default PopUp;